import React, { Component } from 'react';
import FullScreenSlider from './FullScreenSlider.js';
import MyLink from './MyLink.js';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
        count: 0,
        on: false
    };

    // bind methods
    this.intervalFn = this.intervalFn.bind(this);
    this.interval = null;
  }

  intervalFn(){
    this.setState({ 
      count: this.state.count > 7 ? 0 : this.state.count + 1,
      on: this.state.count === 0 || this.state.count === 2 || this.state.count === 3 ? true : false
    });
  }

  componentDidMount(){
    var _this = this;
    setTimeout(function(){
      _this.interval = setInterval(_this.intervalFn, 250);
    },1500);
  }

  render() {

    var bar = this.state.on ? '|' : '';
    
    var dotsEl = <span className="bar">{ bar }</span>;


    return (
      <div className="App">
        <FullScreenSlider></FullScreenSlider>
      
        <div className="App-header">
          <div className="titleWrapper">
            {dotsEl}<h1>{this.props.title}</h1>
          </div>
          <MyLink type="github" name="enrico-atzeni"></MyLink>
          <MyLink type="tw" name="atzeniEn"></MyLink>
          <MyLink type="wp" name="eatzeni"></MyLink>
          <MyLink type="linkedin" name="atzenien"></MyLink>
          <MyLink type="cv" name="http://enricoatzeni.it/media/cv-en.pdf"></MyLink>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js